"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pump = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const PumpTypes_1 = require("../DefinitionAndHelpers/Definitions/Others/PumpTypes");
const typeName = 'Pump';
class Pump extends datamodel_core_1.DeviceEnabledType {
    // constructor(type: string, ob: Partial<PumpType> = {}) {
    //   super(ob.type ?? typeName, ob)
    constructor(ob) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        super(ob.type || typeName, ob);
        this.location = (_a = ob.location) !== null && _a !== void 0 ? _a : undefined;
        this.pumpType = (_b = ob.pumpType) !== null && _b !== void 0 ? _b : 'Vibration';
        this.pumpOnOff = (_c = ob.pumpOnOff) !== null && _c !== void 0 ? _c : false;
        this.manualControl = (_d = ob.manualControl) !== null && _d !== void 0 ? _d : null;
        this.updated_at = (_e = ob.updated_at) !== null && _e !== void 0 ? _e : null;
        this.invalidControl = (_f = ob.invalidControl) !== null && _f !== void 0 ? _f : false;
        this.lastActive = (_g = ob.lastActive) !== null && _g !== void 0 ? _g : null;
        this.lastSeen = (_h = ob.lastSeen) !== null && _h !== void 0 ? _h : null;
        this.updated_at = (_j = ob.updated_at) !== null && _j !== void 0 ? _j : null;
        // this.modules = ob.modules ?? null
    }
    // modules: string[] | null
    changePumpState() {
        if (this.pumpType !== null) {
            return this.pumpOnOff ? this.turnOffPump() : this.turnOnPump();
        }
        return null;
    }
    /**
     * The turnOn function returns an array, as double relays require two payloads to turn on the device.
     * This is done as assuming there is an array of actions to do is easier, as compared to checking if the output is an array or not
     */
    turnOnPump() {
        if (this.pumpType) {
            switch (this.pumpType) {
                case 'Single Relay':
                    return [
                        {
                            pumpControlRelay1: true,
                        },
                    ];
                case 'Double Relay':
                    return [
                        {
                            pumpControlRelay1: true,
                        },
                        {
                            pumpControlRelay1: false,
                        },
                    ];
            }
        }
        return null;
    }
    /**
     * The turnOff function returns an array, as double relays require two payloads to turn on the device.
     * This is done as assuming there is an array of actions to do is easier, as compared to checking if the output is an array or not
     */
    turnOffPump() {
        if (this.pumpType) {
            switch (this.pumpType) {
                case 'Single Relay':
                    return [
                        {
                            pumpControlRelay1: false,
                        },
                    ];
                case 'Double Relay':
                    return [
                        {
                            pumpControlRelay2: true,
                        },
                        {
                            pumpControlRelay2: false,
                        },
                    ];
            }
        }
        return null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Name',
                name: 'name',
                description: 'Name of Water Flow Meter',
            },
            pumpType: { type: 'Enum', editable: true, required: true, label: 'Pump Type', description: 'Pump Type', enumKv: PumpTypes_1.PumpTypeEnum },
            // modules: { type: 'Enum', editable: true, required: true, label: 'Modules', description: 'Allowed Modules TO BE OVERWRITTEN', enumKv: undefined },
            pumpOnOff: {
                type: 'Boolean',
                editable: false,
                label: 'Active Pump',
                name: 'Active Pump',
                description: 'Is the pump active',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
        };
    }
}
exports.Pump = Pump;
